import LoadingSpinner from 'components/loading/LoadingSpinner';
import { dollarsNoCentsWithSymbol } from 'helpers/currency';
import { BoatPackage, TripCalculator } from 'swagger/models';
import styled from 'styled-components';
import { Flex } from 'components/primitives/flex';

interface PriceExclFeesProps {
  primaryPackage: BoatPackage;
  isLoading: boolean;
  isIdle: boolean;
  tripCalculation: TripCalculator;
  isBookingMultiDay: boolean;
  bookingDuration: { label: string };
}
export default ({
  primaryPackage,
  isLoading,
  isIdle,
  tripCalculation,
  isBookingMultiDay,
  bookingDuration,
}: PriceExclFeesProps) =>
  primaryPackage ? (
    <TopAmount gap="5px">
      <BoldAmount data-testid="pdp-booking-widget-package-amount-value">
        {isLoading || isIdle ? (
          <LoadingWrapper>
            <LoadingSpinner color="#72D4BA" />
          </LoadingWrapper>
        ) : (
          dollarsNoCentsWithSymbol(tripCalculation?.pre_tax_and_fees_booking_total || 0)
        )}
      </BoldAmount>
      <Suffix>
        / {isBookingMultiDay ? bookingDuration?.label : bookingDuration?.label?.replace('hours', 'hr')} (excl. fees)
      </Suffix>
    </TopAmount>
  ) : null;

const TopAmount = styled(Flex)`
  border-bottom: 1px solid rgba(219, 223, 229, 0.5);
  padding-bottom: 15px;
`;

const BoldAmount = styled.div`
  font-weight: 700;
  font-size: 20px;
`;

const LoadingWrapper = styled.div`
  width: 25px;
  transform: scale(0.7);
  padding-top: 15px;
  padding-left: 15px;
`;

const Suffix = styled.div`
  font-weight: 500;
  color: #8e9697;
  line-height: 30px;
`;
